module.exports = __webpack_public_path__ + "static/media/fly0077.80475b31.webp";